import React from 'react';

const SvgComponent = props => (
  <svg
    width={81}
    height={104}
    viewBox="0 0 81 104"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        d="M62.1013 18.6097C61.4864 20.2237 60.4872 21.5303 59.1038 22.0683C59.3343 22.8369 59.4881 23.6055 59.4881 24.451V28.2939H63.331C63.869 28.2939 64.4071 28.4476 64.8682 28.6014C64.4839 13.9981 61.3327 11.1543 61.3327 11.1543C62.3319 13.9981 62.4856 16.6113 62.1013 18.6097Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.4426 28.3706V24.5276C21.4426 23.759 21.5963 23.0673 21.75 22.3756C20.0591 21.9144 18.9062 20.5309 18.2145 18.7632C17.907 17.1491 17.907 15.1508 18.3682 12.9219C17.4459 15.0739 16.1393 19.6086 15.9087 28.7549C16.4467 28.5243 16.9847 28.3706 17.5996 28.3706H21.4426Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M64.9458 28.6785C64.4847 28.448 63.9467 28.3711 63.4086 28.3711H59.5657V38.9008H63.2549C63.8698 38.9008 64.4847 38.7471 65.0227 38.5165C66.4062 37.8248 67.3285 36.4413 67.3285 34.8273V32.3678C67.3285 30.6769 66.3293 29.2934 64.9458 28.6785Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.6002 28.3711C16.9853 28.3711 16.4473 28.5248 15.9093 28.7554C14.6027 29.3703 13.6035 30.7537 13.6035 32.2909V34.7504C13.6035 36.3645 14.5258 37.6711 15.8324 38.3628C16.3705 38.6702 17.0622 38.824 17.6771 38.824H21.3663V28.3711H17.6002Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.5035 59.5776C36.7374 59.5776 33.2019 58.5016 30.2043 56.5801V72.4131H50.5721V56.6569C47.7283 58.5016 44.2696 59.5776 40.5035 59.5776Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M59.0273 22.1465C58.4893 22.3771 57.8744 22.5308 57.2596 22.5308H22.5191C22.2117 22.5308 21.9811 22.4539 21.7506 22.3771C21.52 23.0688 21.4431 23.7605 21.4431 24.5291V28.3721V38.9018V40.439C21.4431 47.2026 24.9786 53.1208 30.2819 56.5026C33.2794 58.4241 36.815 59.5001 40.5811 59.5001C44.2703 59.5001 47.729 58.4241 50.6497 56.5795C55.9529 53.2745 59.4885 47.3563 59.4885 40.5927V38.825V28.3721V24.5291C59.4885 23.6837 59.3348 22.8382 59.0273 22.1465Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.4431 28.3711V38.9008V28.3711Z"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M61.4117 11.2316C61.258 10.7705 61.1043 10.2325 60.8737 9.77132C57.8762 2.54654 48.115 0.855637 38.3539 1.00936C29.8225 1.31679 22.0597 3.46885 19.3696 9.69446C18.9085 10.7705 18.6011 11.8465 18.3705 12.9226C17.9093 15.1515 17.8325 17.1498 18.2168 18.7639C18.9085 20.5316 20.0614 21.9151 21.7523 22.3762C21.9829 22.4531 22.2903 22.53 22.5209 22.53H57.2613C57.953 22.53 58.4911 22.3762 59.0291 22.1457C60.4125 21.5308 61.4117 20.2242 62.0266 18.687C62.4877 16.6118 62.334 13.9986 61.4117 11.2316Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M71.6337 69.337L56.3387 64.418H24.5958L9.30081 69.337C4.30495 71.2585 1 76.0237 1 81.327V102.07H79.9345V81.327C79.9345 76.0237 76.6296 71.2585 71.6337 69.337Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.4285 101.312L55.9541 64.7266L61.7185 72.4125L43.8033 96.128"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.9792 64.7266L38.6602 97.0843L19.1379 72.4125L24.9792 64.7266Z"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4301 37.9955C12.0938 41.178 8.86794 49.9469 13.6767 55.8377C18.4855 61.7286 26.742 61.0734 30.6166 59.1278"
        stroke="#2F6ECD"
        strokeWidth="2"
      />
      <path
        d="M66.5253 37.9232C68.8616 41.1057 72.0874 49.8746 67.2786 55.7655C62.4698 61.6563 54.2133 61.0011 50.3387 59.0556"
        stroke="#2F6ECD"
        strokeWidth="2"
      />
    </g>
  </svg>
);

export default SvgComponent;
